import {LocalStorageService} from 'src/app/local-storage.service';
import {SwissAppConfigModels} from 'src/app/models/swissappconfig-models';
import {from, tap} from 'rxjs';
import {takeUntilDestroyed} from '@angular/core/rxjs-interop';
import {BenutzerModels} from '../../models/benutzer-models';
import {SwissInternModels} from '../../models/swissintern-models';
import {DestroyRef, inject} from '@angular/core';
import {UserAuthenticationService} from '../../services/user-authentication.service';
import UserLicenses = BenutzerModels.UserLicenses;
import StartSite = SwissInternModels.StartSite;
import {SwissSettingsService} from '../../services/swiss-settings.service';

export class AppEinstellungenBaseComponent {
    public storageWebMain = 'SwissWebMainDB';
    public storageWebConfig = 'SwissWebConfigDB';
    public storageServiceApp = 'ServiceAppDB';
    public swissAppUserConfig?: SwissAppConfigModels.SwissAppUserConfig;
    public startSites: StartSite[] = [
        {value: 0, viewValue: ''}
    ];
    public timeGridStart = '06:00';
    public timeGridEnd = '20:00';
    public timeWorkDayStart = '07:00';
    public timeWorkDayEnd = '19:00';
    public startPage?: number;
    public destroyRef = inject(DestroyRef);

    constructor(public localStorageService: LocalStorageService, public userAuthService: UserAuthenticationService, public svcSwissSettings: SwissSettingsService) {
    }

    setStartPageOptions(): void {
        from(this.userAuthService.hasLicences(UserLicenses.CNavigatorMobile)).pipe(takeUntilDestroyed(this.destroyRef)).subscribe(hasLicence => {
            if (hasLicence) {
                this.startSites.push(
                    {value: 1, viewValue: 'Dashboard'},
                    {value: 2, viewValue: 'Adressen'},
                    {value: 3, viewValue: 'Objekte'},
                    {value: 4, viewValue: 'Pendenzen'}
                );
            }
        });

        from(this.userAuthService.hasLicences(UserLicenses.CServiceApp)).pipe(takeUntilDestroyed(this.destroyRef)).subscribe(hasLicence => {
            if (hasLicence) {
                this.startSites.push({value: 5, viewValue: 'Service-App'});
            }
        });


        from(this.userAuthService.hasLicences(UserLicenses.CMobileTime)).pipe(takeUntilDestroyed(this.destroyRef)).subscribe(hasLicence => {
            if (hasLicence) {
                this.startSites.push({value: 6, viewValue: 'Time-App'});
            }
        });
    }

    async loadAppUserConfig(): Promise<void> {
        this.svcSwissSettings.getSwissAppUserConfig$().pipe(
            takeUntilDestroyed(this.destroyRef),
            tap((userConfig) => {
                this.swissAppUserConfig = userConfig;
                this.timeGridStart = userConfig.timeGridStart;
                this.timeGridEnd = userConfig.timeGridEnd;
                this.timeWorkDayStart = userConfig.timeGridWorkDayStart;
                this.timeWorkDayEnd = userConfig.timeGridWorkDayEnd;
                this.startPage = userConfig.startPage;
            })
        ).subscribe();
    }

    async webEditionDeleteOfflineData(): Promise<void> {
        await this.localStorageService.add('offlineObjektAktivitaeten', [], this.storageWebMain, false, true);
        await this.localStorageService.add('offlineObjektAktivitaetenDateien', [], this.storageWebMain, false, true);
        await this.localStorageService.add('offlineObjektBaum', [], this.storageWebMain);
        await this.localStorageService.add('offlineObjektBezeichnungen', [], this.storageWebMain, false, true);
        await this.localStorageService.add('offlineObjekte', [], this.storageWebMain, false, true);
        await this.localStorageService.add('offlineObjektTypen', [], this.storageWebMain, false, true);
        await this.localStorageService.add('offlineObjekteAdressZuord', [], this.storageWebMain, false, true);
        await this.localStorageService.add('offlineObjekteAdressen', [], this.storageWebMain, false, true);
    }

    delay(ms: number): Promise<any> {
        return new Promise((resolve) => setTimeout(resolve, ms));
    }
}
